<aside class="esf-main-sidebar esf-main-sidebar--working-space -has-transition"
       [ngClass]="{'-is-open': isOpen}" [hidden]="!isOpen">
  <div class="esf-main-sidebar__content">
    <h3>
      <span i18n='@@importCustomer.workspaceTitle.uploadImport'>Upload import</span>
    </h3>
  </div>

  <div class="esf-form-item">
    <label for="importData" id="importCustomer" class="esf-button esf-button--standard esf-button--outlined esf-file-upload__button">
      <svg class="esf-icon esf-button__icon" width="16" height="16">
        <use xlink:href="#esf-icon-upload"></use>
      </svg>
      <span id="importFileLabel" class="esf-button__icon-text">
        <span *ngIf="fileLabel">{{ fileLabel }}</span>
        <span *ngIf="!fileLabel" i18n='@@general.selectOption.selectFile'>Select a file</span>
      </span>
    </label>
    <input class="esf-form-item__field esf-file-upload__input" type="file" id="importData" (change)="onFileChange($event.target)" #fileInput>
  </div>

</aside>

<div class="esf-main-sidebar--working-space__actions -has-transition" [ngClass]="{'-is-open': isOpen}">
  <app-submit-row-buttons [cancelButtonText]="buttonsTranslations.i18nBack"
                          [submitButtonText]="buttonsTranslations.i18nSubmit"
                          [isFieldValid]="fileToUpload !== null"
                          [spinnerName]="spinnerName"
                          (cancelButton)="setIsOpen(false)"
                          (submitButton)="onSubmit()">
  </app-submit-row-buttons>
</div>

<div class="esf-hamburger esf-hamburger--working-space -has-transition"
     [ngClass]="{'-is-open': isOpen }" (click)="setIsOpen(false)">
  <span class="esf-hamburger__icon"></span>
</div>
